export const getLastCategoryLevel = (route) => {
    for (let i = 4; i > -1; i--) {
        if (route.params[`lvl${i}`]) return i
    }

    return undefined
}
